export default __webpack_public_path__ + "static/media/photo10.017a12a5.jpg";